import React, { useState, useEffect } from "react";

function Pagination({ currentPage, totalPages, onPageChange }) {
  const [selectedPage, setSelectedPage] = useState(currentPage);
  const [startPage, setStartPage] = useState(1);
  const pageNumbers = [];

  useEffect(() => {
    setSelectedPage(currentPage);
    setStartPage(Math.floor((currentPage - 1) / 5) * 5 + 1);
  }, [currentPage]);

  for (let i = startPage; i < startPage + 5 && i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageClick = (number) => {
    setSelectedPage(number);
    onPageChange(number);
  };

  const handleNextClick = () => {
    const newStartPage = Math.min(
      startPage + 5,
      Math.floor((totalPages - 1) / 5) * 5 + 1
    );
    setStartPage(newStartPage);
    setSelectedPage(newStartPage);
    onPageChange(newStartPage);
  };

  const handleBackClick = () => {
    const newStartPage = Math.max(1, startPage - 5);
    setStartPage(newStartPage);
    setSelectedPage(newStartPage);
    onPageChange(newStartPage);
  };

  return (
    <div className="flex justify-end items-center mt-8 mb-8 space-x-2">
      <button
        className="px-3 py-1 bg-white rounded border"
        onClick={handleBackClick}
        disabled={startPage === 1}
      >
        Back
      </button>

      {pageNumbers.map((number) => (
        <button
          key={number}
          className={`px-3 py-1 rounded ${
            selectedPage === number ? "bg-black text-white" : "bg-white border"
          }`}
          onClick={() => handlePageClick(number)}
        >
          {number}
        </button>
      ))}

      <button
        className="px-3 py-1 bg-white rounded border"
        onClick={handleNextClick}
        disabled={startPage + 5 > totalPages}
      >
        Next
      </button>
    </div>
  );
}

export default Pagination;
